<template>
  <div class="useral-edit-profile">
    <vs-divider class="md:hidden"/>

    <div class="view-side mt-3 sm:mt-0">
      <div class="view-box">
        <vs-row>
          <vs-col>
            <custom-profile-image-input v-model="user.image"/>

            <div>
              <div class="input-field-item" :class="user.gender.id === -1 ? 'invalid' : ''">
                <label class="input-field-label">{{ $t('profile.edit.labels.gender') }}</label>
                <div v-for="(item, key) in gender" :key="key" class="radio-item">
                  <label :for="`genderRadio${key}`">{{ item.label }}</label>
                  <input :id="`genderRadio${key}`" type="radio" :key="key" name="refereee" :value="item.id"
                         v-model="user.gender.id"/>
                </div>
              </div>


              <custom-validate-input :label="$t('profile.edit.labels.name')"
                                     :classes="{'w-full': true}"
                                     align="right"
                                     rtl
                                     :invalid-text="$t('profile.edit.invalidTexts.name')"
                                     :regex="nameRegex"
                                     v-model="user.name"/>

              <custom-validate-input :label="$t('profile.edit.labels.family')"
                                     :classes="{'w-full': true}"
                                     align="right"
                                     rtl
                                     :invalid-text="$t('profile.edit.invalidTexts.family')"
                                     :regex="nameRegex"
                                     v-model="user.lastName"/>
              <custom-phone-number-input :label="$t('profile.edit.labels.phoneNumber')"
                                         :classes="{'w-full': true}"
                                         is-empty
                                         :disabled="true"
                                         :value="user.phoneNumber"/>

            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>

    <vs-button v-show="false"
               id="EditProfileBTN"
               @click="sendData"/>
  </div>
</template>

<script>
  import axios from 'axios'
  import CustomValidateInput from '../../../../components/customInput/customValidateInput'
  import CustomPhoneNumberInput from '../../../../components/customInput/customPhoneNumberInput'
  import {editProfile, getProfile} from '../../../../http/requests/users/users'
  import {getRoles} from '../../../../http/requests/roles'
  import {checkUserPermissions} from '../../../../assets/js/functions'
  import CustomProfileImageInput from "../../../../components/customInput/customProfileImageInput";
  import {getCharacters} from "../../../../http/requests/characters";

  export default {
    name: 'editProfile',
    components: {
      CustomProfileImageInput,
      CustomPhoneNumberInput,
      CustomValidateInput
    },
    props: {
      userId: 0
    },
    data() {
      return {
        nameRegex: this.$validator('regex.user.name'),
        characters: [],
        gender: [
          {
            id: 1,
            label: this.$t('genderTypes.man')
          },
          {
            id: 2,
            label: this.$t('genderTypes.woman')
          }
        ],
        user: {
          name: {
            value: '',
            isValid: true
          },
          lastName: {
            value: '',
            isValid: true
          },
          fatherName: {
            value: '',
            isValid: true
          },
          nationalCode: {
            value: '',
            isValid: false
          },
          image: {
            value: '',
            isValid: true
          },
          birthDate: {
            value: '',
            isValid: true
          },
          gender: {
            id: -1,
            label: this.$t('genderTypes.man')
          },
          phoneNumber: {
            value: '',
            isValid: true
          },
          email: {
            value: '',
            isValid: true
          },
          birthProvince: {
            id: '',
            label: ''
          },
          province: {
            id: '',
            label: ''
          },
          address: {
            value: '',
            isValid: true
          },
          city: {
            id: '',
            label: ''
          },
          character: {
            id: 1
          },
          role: {
            label: '-',
            value: null
          },
          balance: 0,
          maxDebt: 0,
        },
        roles: []
      }
    },
    created() {
      this.getUser()
      if (checkUserPermissions('role.show')) {
        this.getAccessGroups()
      }
      if (checkUserPermissions('character.show')) {
        this.getCharacters()
      }
    },
    methods: {
      getUser() {
        getProfile().then(response => {
          const user = response.data.data

          this.user = {
            id: user.id,
            image: {
              value: user.avatar || '',
              isValid: true
            },
            name: {
              value: user.name,
              isValid: ''
            },
            companyName: {
              value: '',
              isValid: ''
            },
            lastName: {
              value: user.family,
              isValid: ''
            },
            gender: {
              id: user.gender
            },
            email: {
              value: user.email ? user.email : '',
              isValid: ''
            },
            phoneNumber: {
              value: user.phone_number,
              isValid: ''
            },
            financial: {
              maxDebt: user.maxDebt ? user.maxDebt : 0,
              balance: user.balance ? user.balance : 0
            }
          }
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
                text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            }
          })
      },
      getCharacters() {
        getCharacters().then(response => {
          const characters = response.data.data
          characters.forEach(character => {
            this.characters.push({
              id: character.id,
              label: character.name
            })
          })
        })
      },
      getAccessGroups() {
        getRoles().then(response => {
          this.roles = this.getRoles(response.data.data)
        })
      },
      getRoles(role) {
        let roles = [
          {
            label: role.name,
            value: role.id
          }
        ]

        if (role.children && role.children.length > 0) {
          role.children.forEach((child) => {
            roles = [...roles, ...this.getRoles(child)]
          })
        }
        return roles
      },
      checkUserPermissions(permission) {
        return checkUserPermissions(permission)
      },
      sendData() {
        if (this.user.gender.id === -1) {

          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('profile.notifications.parseError.gender'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        }
        if (!this.user.name.isValid) {

          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('profile.notifications.parseError.name'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        }
        if (!this.user.lastName.isValid) {

          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('profile.notifications.parseError.family'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'danger'
          })
          return false
        }

        const user = {
          name: this.user.name.value,
          family: this.user.lastName.value,
          avatar: this.user.image ? this.user.image.value : '',
          gender: this.user.gender.id,
          phone_number: this.user.phoneNumber.value,
          company: '',
        }

        editProfile(user).then(() => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('profile.notifications.edit.success'),
            icon: 'icon-check',
            iconPack: 'feather',
            time: 2400,
            color: 'success'
          })
          this.$emit('edited')
        }).catch((error) => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {

            const error_mapper = {
              'name': this.$t('profile.notifications.parseError.name'),
              'family': this.$t('profile.notifications.parseError.family'),
              'avatar': this.$t('profile.notifications.parseError.avatar'),
              'gender': this.$t('profile.notifications.parseError.gender'),
              'phone_number': this.$t('profile.notifications.parseError.phoneNumber'),
            }

            switch (error.response.status) {
              case 422:
                Object.keys(error.response.data.errors).forEach((error_key) => {
                  const err = error_key.toString().split('.')
                  if (error_mapper[err[err.length - 1]]) {
                    this.$vs.notify({
                      title: this.$t('alert.error.title'),
                      text: error_mapper[err[err.length - 1]],
                      color: 'danger',
                      icon: 'icon-alert-circle',
                      iconPack: 'feather',
                      time: 2400
                    })
                    error_mapper[err[err.length - 1]] = null
                  }
                })
                break

              default:
                this.$vs.notify({
                  title: this.$t('alert.error.title'),
                  text: this.$t('profile.notifications.edit.error'),
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400
                })
                break
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .useral-edit-profile {
    width: 100%;
    height: calc(100% - 10px);
    display: flex;

    @media (max-width: 767px) {
      display: block;
    }

    .view-side {
      flex-grow: 1;
      height: 100%;
      border: 1px solid #cecece;
      padding: 5px;
      border-radius: .5rem;
      overflow-y: auto;


      @media (max-width: 767px) {
        width: 100%;
        min-width: 100%;
        height: calc(100% - 230px);
      }

      .view-box {
        width: 100%;
        height: 100%;
        padding: 5px;
        overflow: auto;

        .custom-profile-image-input {
          .profile-image-label {
            height: 110px;
            width: 110px;
          }
        }

        .date-picker-item {
          border: 0 !important;
          border-radius: 0.4rem;
          position: relative;

          .date-picker-label {
            font-size: 12px;
            position: absolute;
            top: -10px;
            left: 5px;
            padding: 0 5px;
            background-color: #ffffff;
            z-index: 1;
          }

          .vpd-input-group {
            width: 20px !important;
            position: absolute;
            top: 6px;
            left: 2px;

            .vpd-icon-btn {
              opacity: 1 !important;
              height: 25px !important;
              width: 20px !important;
              background-color: inherit !important;

              svg {
                fill: #000000;
                overflow: visible !important;
              }
            }

            .form-control {
              border: 0;
              width: 100%;
              display: none;
              line-height: 35px;
            }
          }
        }

        .input-field-item {
          position: relative;
          border: 1px solid #cdcdcd;
          border-radius: 0.4rem;
          padding: 5px 10px;
          margin: 15px 0;
          display: flex;
          justify-content: space-around;
          min-height: 35px;
          flex-wrap: wrap;

          &.character-input {
            justify-content: space-between;
          }

          &.invalid {
            border-color: #b00000;

            .input-field-label {
              color: #b00000;
            }
          }

          .input-field-label {
            position: absolute;
            font-size: 12px;
            top: -10px;
            left: 8px;
            background-color: #ffffff;
            padding: 0 5px;
          }

          .radio-item {
            display: flex;
            align-items: center;
            width: max-content;
            direction: rtl;

            label {
              direction: ltr;
              margin-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          &.character-input {
            justify-content: space-between;

            .radio-item {
              justify-content: flex-end;
              width: 33%;
            }
          }
        }

        div.edit-user-field {
          position: relative;

          span.label {
            font-size: 12px;
            position: absolute;
            top: -10px;
            left: 7px;
            z-index: 10000;
            background: #ffffff;
            padding: 0 5px;
          }

          .useral-custom-element-select {
            margin: 15px 0;

            .selected {
              height: 35px;
              line-height: 35px;
              font-size: 13px;
            }

            .items {
              line-height: 35px;

              div {
                height: 35px;
                font-size: 13px;
              }
            }
          }
        }

        .error-alert {
          display: inline-block;
          border: 1px solid #ffba00;
          border-radius: .5rem;
          color: #ffba00;
          padding: 0 10px;
          line-height: 50px;
          height: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 15px;

          i {
            font-size: 15px;
          }
        }

        &::-webkit-scrollbar {
          display: block;
          border-radius: .2rem;
          width: 10px;
          background: #f9f9fd;
          right: 10px;
        }

        &::-webkit-scrollbar-thumb {
          display: block;
          border-radius: .2rem;
          background: #cecece;
        }
      }
    }
  }
</style>
